module.exports = __webpack_public_path__ + "static/img/jprm.d7893f41.png";